import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Tax.scss";
import Image from "react-bootstrap/Image";
import taxImg1 from "../../assets/images/tax-service1.jpg";
import taxImg2 from "../../assets/images/tax-service2.jpg";

import { useTranslation } from "react-i18next";

const Tax = () => {
  const { t } = useTranslation(["common","tax"]);

  return (
    <div className="MainbBody TaxService">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <h3>{t('tax:title')}</h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={taxImg1} alt="Tax Service"/>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('tax:text_0.title')}</strong></p>
                  <p>{t('tax:text_0.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('tax:text_1.title')}</strong></p>
                  <p>{t('tax:text_1.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={taxImg2} alt="Tax Service"/>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('tax:text_2.title')}</strong></p>
                  <p>{t('tax:text_2.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('tax:text_3.title')}</strong></p>
                  <p>{t('tax:text_3.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('tax:text_4.title')}</strong></p>
                  <p>{t('tax:text_4.text')}</p>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={taxImg2} alt="Tax Service"/>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('tax:text_5.title')}</strong></p>
                  <p>{t('tax:text_5.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

        </Container>
      </div>
    </div>
  );
};

export default Tax;
